<div class="tabs_menu_top">
	<ul>
		<li
			class="top_active"
			*ngFor="let tab of tabs"
			[ngClass]="{ top_active: tab.active === true }"
			(click)="selectTab(tab)"
		>
			<a>{{ tab.tabTitle }} </a>
		</li>
	</ul>
</div>
<ng-content></ng-content>
